export default "__VITE_ASSET__b10983ab__"